import { render } from "./CredentialsErrorBlock.vue?vue&type=template&id=d5281036"
import script from "./CredentialsErrorBlock.vue?vue&type=script&lang=ts"
export * from "./CredentialsErrorBlock.vue?vue&type=script&lang=ts"
script.render = render

export default script